<template>
  <nav class="page-top-navbar" ref="navbar" :class="{'is-fixed': isFixed}">
      <router-link :to="{name: 'home'}" class="logo">
        <img src="@/assets/img/svg/logo_icone_esquerda.svg" width="200">
      </router-link>
      <span class="flex-1"></span>
      <div class="flex-1 top-button-center">
            <a href="http://www.contatoseguro.com.br/crivelli" target="_blank" class="button button-orange">
                Canal de Denúncia
            </a>
        </div>
        <span class="flex-1"></span>
      <div class="tel">
        <label class="hidden-mobile">Precisa de Ajuda?</label>
        <a href="tel:1133760110">
          <img src="@/assets/img/svg/whatsapp.svg" width="30">
          <small class="hidden-mobile">(11)</small><span class="hidden-mobile">3376-0100</span>
        </a>
      </div>
      <a class="menu-control" @click="toggleMenu">
        <img src="@/assets/img/svg/close.svg" width="45" v-if="menuOpened">
        <template v-else><span class="hidden-mobile">Menu</span><img src="@/assets/img/svg/menu.svg" width="50"> </template>
      </a>
    </nav>
</template>

<script>
export default {

    props: {
        isFixed: Boolean,
        menuOpened: Boolean,
    },

    methods: {
        toggleMenu() {
            this.$emit('update:menuOpened', !this.menuOpened);
        }
    }
}
</script>

<style>

</style>
